import React, { useEffect, useState } from "react";
import Layout, { Container } from "../components/layout";
import axios from "axios";
import { apiurl } from "../config/config";
import { useUser } from "../config/userProvider";
import { Link, useNavigate } from "react-router-dom";
import { InfiLoader } from "../components/loader";
import ButtonContainer from "../components/buttonContainer";
import { IoAddOutline } from "react-icons/io5";
import SearchContainer from "../components/searchContainer";
import BackHeader from "../components/backHeader";
import DataNotFound from "../components/dataNotFound";
import { toast } from "react-toastify";
import Card from "../components/card";
import Pagination from "../components/pagination";
// import { AiTwotoneEdit } from "react-icons/ai";
// import { RiDeleteBin6Fill } from "react-icons/ri";
// import { FiSearch } from "react-icons/fi";
// import { IoMdAddCircle } from "react-icons/io";
// import { PopModel } from "../components/popupModels";

function Segments() {
  const { userData } = useUser();
  const navigate = useNavigate();
  const vendorObjId = userData?.vendorDetails?.vendorObjId;
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleteSegmentsLoading, setDeleteSegmentsLoading] = useState(false);
  // const [isDeleted, WantToDelete] = useState(false);
  const [deleteSegmentIds, setDeleteSegmentIds] = useState([]);

  console.log("CUSTOMERS IS :========>>>>>>", customers);

  const [searchInput, setSearchInput] = useState("");

  // =================== PAGINATION =================
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationData, setPaginationData] = useState("");
  // const [deleteCustomerIds, setDeleteCustomerIds] = useState([]);
  const [isDeleted, WantToDelete] = useState(false);

  // Calculate the current items to display
  // const indexOfLastItem = currentPage * itemsPerPage;
  // const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // =======================================================

  console.log("paginationData", paginationData);
  const fetchCustomerData = async (vendorObjId) => {
    setLoading(true);
    let payload = JSON.stringify({
      vendorObjId: vendorObjId,
      page: currentPage,
      limit: JSON.parse(itemsPerPage),
    });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiurl}/admin/v1/segment/get`,
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Segment Data:", response.data.data);
        // setAppData(response.data.data);
        // setLoading(false);
        setCustomers(response?.data?.data);
        setLoading(false);
        setPaginationData(response?.data?.pagination);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };
  const handleEditCustomer = (id) => {
    navigate(`/customers/segments/${id}`);
  };

  // useEffect(() => {
  //   if (userData?.vendorDetails?.vendorObjId) {
  //     fetchCustomerData(userData?.vendorDetails?.vendorObjId);
  //   }
  // }, [currentPage, itemsPerPage]);
  useEffect(() => {
    if (userData?.vendorDetails?.vendorObjId) {
      fetchCustomerData(userData.vendorDetails.vendorObjId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, itemsPerPage, userData?.vendorDetails?.vendorObjId]);

  // const filterdata = customers.filter(
  //   (customer) =>
  //     customer.name.toLowerCase().includes(searchInput.toLowerCase()) ||
  //     customer.phone.toLowerCase().includes(searchInput.toLowerCase())
  // );

  const filterdata =
    customers &&
    customers.filter((customer) => {
      const name = customer.name || ""; // Fallback to empty string if name is undefined
      const phone = customer.phone || ""; // Fallback to empty string if phone is undefined

      return (
        name.toLowerCase().includes(searchInput.toLowerCase()) ||
        phone.toLowerCase().includes(searchInput.toLowerCase())
      );
    });

  const AllCheckedHandler = () => {
    if (filterdata.length !== deleteSegmentIds.length) {
      filterdata.forEach((item) =>
        setDeleteSegmentIds((prev) => [...prev, item._id]),
      );
    } else {
      setDeleteSegmentIds([]);
    }
  };

  const CheckedHandler = (id) => {
    const contain = deleteSegmentIds.includes(id);
    console.log("containcontain", contain, id);
    if (contain) {
      setDeleteSegmentIds(deleteSegmentIds.filter((i) => i !== id));
    } else {
      setDeleteSegmentIds((prev) => [...prev, id]);
    }
  };

  const DeleteHandler = () => {
    setDeleteSegmentsLoading(true);
    let data = JSON.stringify({
      segmentObjIds: deleteSegmentIds,
    });
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiurl}/admin/v1/segment/delete`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        if (response.data.success) {
          toast.success(
            response.data.message
              ? response.data.message
              : "Segment deleted successfully",
          );
          WantToDelete(false);
          fetchCustomerData(vendorObjId);
          setDeleteSegmentsLoading(false);
          // setDeleteCustomerIds([]);
        } else {
          toast.error(
            response?.data?.message
              ? response?.data?.message
              : "Failed to delete Segment",
          );
          setDeleteSegmentsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error("Failed to delete segment, Please try again later.");
        setDeleteSegmentsLoading(false);
      });
  };

  return (
    <Layout>
      {isDeleted && (
        <Card.Confirmation
          message="Are you sure?"
          onConfirm={() => DeleteHandler()}
          onClose={() => WantToDelete(false)}
          loading={deleteSegmentsLoading}
          loadingTitle="Deleting..."
        />
      )}
      <Container>
        {loading === true ? (
          <InfiLoader maintext="Fetching Segments Data..." />
        ) : (
          <div className=" rounded-lg h-full w-full overflow-x-auto px-2 md:px-5 ">
            <div className="h-[92%] overflow-hidden">
              <BackHeader
                // title="Our Customers"
                title={
                  <span className="flex flex-col md:flex-row items-center">
                    Segments
                    <span className="hidden lg:flex">
                      {" "}
                      - {paginationData?.totalsegments}
                    </span>
                    <select
                      value={itemsPerPage}
                      className="text-xs rounded text-black border px-2 mx-2"
                      onChange={(e) => setItemsPerPage(e.target.value)}
                    >
                      {/* <option value="10">10</option> */}
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="250">250</option>
                      <option value="500">500</option>
                      <option value="1000">1000</option>
                    </select>
                  </span>
                }
                rightSide={
                  <div className="flex items-center gap-2">
                    {deleteSegmentIds.length > 0 &&
                      userData?.userType === "superadmin" && (
                        <button
                          onClick={() => WantToDelete(true)}
                          className="bg-red-50 text-xs hover:bg-[#c00218] border border-red-300 text-[#c00218] hover:text-white rounded-lg px-2 py-1.5 md:py-2 md:px-3 "
                        >
                          Delete
                        </button>
                      )}
                    <div className="flex gap-2 md:hidden">
                      <Link to="/customers/">
                        <ButtonContainer
                          icon={<IoAddOutline />}
                        ></ButtonContainer>
                      </Link>
                    </div>
                    <div className="hidden md:flex gap-2">
                      <Link to="/customers/segments/create">
                        <ButtonContainer icon={<IoAddOutline />}>
                          Create
                        </ButtonContainer>
                      </Link>
                    </div>
                    <div className="hidden md:flex">
                      <SearchContainer
                        value={searchInput}
                        placeholder={"Search Customer..."}
                        onChange={(e) => setSearchInput(e.target.value)}
                      />
                    </div>
                  </div>
                }
              />
              <div className="flex flex-col  h-[90%] overflow-auto mt-2">
                <div className=" h-full sm:rounded-lg">
                  {filterdata && filterdata.length > 0 ? (
                    <table className="w-full text-sm text-left rtl:text-right text-gray-500 max-h-96">
                      <thead className="text-xs text-gray-700 uppercase bg-gray-50 sticky top-0">
                        <tr>
                          <th scope="col" class="p-4">
                            <div class="flex items-center">
                              <input
                                id="checkbox-all-search"
                                type="checkbox"
                                checked={
                                  filterdata.length === deleteSegmentIds.length
                                }
                                onClick={AllCheckedHandler}
                                class="w-3 h-3 lg:w-4 lg:h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2 "
                              />
                              <label for="checkbox-all-search" class="sr-only">
                                checkbox
                              </label>
                            </div>
                          </th>
                          <th scope="col" className="px-6 py-3">
                            Name
                          </th>
                          <th scope="col" className="px-6 py-3">
                            Customer count
                          </th>
                          <th scope="col" className="px-6 py-3">
                            Desciption
                          </th>
                          <th scope="col" className="px-6 py-3">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody className="h-[100%]">
                        {filterdata &&
                          filterdata.length > 0 &&
                          filterdata.map((customer, index) => (
                            <tr
                              key={index}
                              className={`${
                                index % 2 === 0
                                  ? "odd:bg-white"
                                  : "even:bg-gray-50"
                              } border-b cursor-pointer`}
                            >
                              <td class="w-4 p-4">
                                <div class="flex items-center">
                                  <input
                                    id="checkbox-table-search-1"
                                    type="checkbox"
                                    checked={deleteSegmentIds.includes(
                                      customer._id,
                                    )}
                                    onClick={() => CheckedHandler(customer._id)}
                                    class="w-3 h-3 lg:w-4 lg:h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500   focus:ring-2 "
                                  />
                                  <label
                                    for="checkbox-table-search-1"
                                    class="sr-only"
                                  >
                                    checkbox
                                  </label>
                                </div>
                              </td>
                              <th
                                scope="row"
                                className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap"
                              >
                                {customer.name}
                              </th>
                              <td className="px-6 py-4">
                                {customer?.customers?.length}
                              </td>
                              <td className="px-6 py-4">
                                {customer?.description}
                              </td>
                              <td
                                className="px-6 py-4 hover:text-blue-500"
                                onClick={() => handleEditCustomer(customer._id)}
                              >
                                View
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  ) : (
                    <DataNotFound.Page label="Segment" />
                  )}
                </div>
              </div>
            </div>
            <Pagination
              currentPage={currentPage}
              totalItems={paginationData?.totalsegments}
              itemsPerPage={itemsPerPage}
              onPageChange={handlePageChange}
            />
          </div>
        )}
      </Container>
    </Layout>
  );
}

export default Segments;
